import { Component, OnInit, TemplateRef, ViewChild, Renderer2, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { AngularFireDatabase } from '@angular/fire/database';
import { iif, Observable } from 'rxjs';
import { formatDate, DatePipe } from '@angular/common';
import * as firebase from 'firebase/';
import { MatStepper } from '@angular/material/stepper';
import { MatCalendarCellCssClasses } from '@angular/material/datepicker';
import LocationPicker from "location-picker";
import { PDFSource } from 'ng2-pdf-viewer';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2'
import { FichaService } from '../ficha/services/solicitud.services';
import { environment } from 'src/environments/environment.prod';
import { functions } from '../../Helpers/functions'
import { alerts } from '../../Helpers/alerts'
import { data } from '../ficha/data/unidadesEducativas';
import { dataNivel } from '../ficha/data/niveles';
import { ActivatedRoute, Router } from '@angular/router';
import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';


import { MapaComponent } from '../mapa/mapa.component'
export class Location {
  lat: number;
  lng: number;
  name?: string;
  zoom?: number;
  icon?: string;
}
export class Colegio {
  Codigo: string;
  Colegio: string;
  Direccion: string;
  Latitud: number;
  Longitud: number;
  LinkContrato: string;
  TiposServicios: [];
}

@Component({
  selector: 'app-perdido',
  templateUrl: './perdido.component.html',
  styleUrls: ['./perdido.component.css']
})
export class PerdidoComponent implements OnInit {

  @ViewChild(MapaComponent) child;
  @ViewChild('locationDialog') locationDialog: TemplateRef<any>;

  public estudianteAntiguo: Boolean;
  isLinear = true;
  lp: LocationPicker;
  colegioSeleccionado: Colegio;
  codigoColegioEnviado: string;
  ColegioFormGroup: UntypedFormGroup;
  NuevoAntiguoFormGroup: UntypedFormGroup;
  CIEstudianteFormGroup: UntypedFormGroup;
  DatosEstudianteFormGroup: UntypedFormGroup;
  DireccionDomicilioFormGroup: UntypedFormGroup;
  DatosRepresentanteFormGroup: UntypedFormGroup;
  DatosFacturacionFormGroup: UntypedFormGroup;
  DatosServicioTransporteFormGroup: UntypedFormGroup;
  public tieneRetorno: Boolean;
  public locationDireccion: Location;
  public locationDireccionRegreso: Location;
  pdfSrc: string | PDFSource | ArrayBuffer = '../assets/TERMINOS_Y_CONDICIONES.pdf';
  public loading = false;
  LengthFact: number;
  inicia = false
  constructor(private service: FichaService, private renderer: Renderer2
    , private _formBuilder: UntypedFormBuilder, public db: AngularFireDatabase,private _Activatedroute: ActivatedRoute
    , public datePipe: DatePipe, private dialog: MatDialog, private router: Router) {

  }
  public location: Location;
  public handTool = true;
  public page = 5;
  public pageLabel!: string;
  public rotation: 0 | 90 | 180 | 270 = 0;

  public sidebarVisible = true;
  public spread: 'off' | 'even' | 'odd' = 'off';
  public src = '../assets/TERMINOS_Y_CONDICIONES.pdf';
  public zoom: number | string = 'auto';

  direccionRetornoP = false;

  showGif(event: { loaded: number, total: number }) {
    this.loading = event.loaded < event.total;
    //console.log(event.loaded);
  }

  formSubmittedUnidad = false;

  loooo
  dataUnidadEdu = []
  dataNiveles = []
  latitudRecoijida;
  longitudRecojida;

  latitudDeja;
  longitudDeja;
  ngOnInit() {
    this.codigoColegioEnviado = this._Activatedroute.snapshot.paramMap.get("codigoColegioEnviado");
    this.latitudRecoijida = -0.172216
    this.longitudRecojida = -78.460953

    this.latitudDeja = -0.172216
    this.longitudDeja = -78.460953
    this.dataUnidadEdu = data;
    this.dataNiveles = dataNivel;
    //alerts.information("", "", "")

    this.ColegioFormGroup = this._formBuilder.group({
      Colegio: ['',
        Validators.compose([Validators.required])],
      identification: ['', {
        validators: [
          Validators.required, Validators.minLength(10),
          Validators.maxLength(10),
          Validators.pattern('[\\0-9]*')], asyncValidators: [this.cedula()]
      }]
    });


    this.DatosEstudianteFormGroup = this._formBuilder.group({
      apellidosCompletos: ['', Validators.compose([Validators.required, Validators.pattern('[\\a-zA-ZáéíóúñÁÉÍÓÚÑ ]*')])],
      nombresCompletos: ['', Validators.compose([Validators.required, Validators.pattern('[\\a-zA-ZáéíóúñÁÉÍÓÚÑ ]*')])],
      gradoPromovido: ['', Validators.compose([Validators.required])],
      paralelo: ['', Validators.compose([Validators.required])],
      edad: ['', Validators.compose([Validators.required, Validators.pattern('[\\0-9]*')])],

      callePrincipal: ['', Validators.compose([Validators.required])],
      calleSecundaria: ['', Validators.compose([Validators.required])],
      casaNo: ['', Validators.compose([Validators.required])],
      referencia: ['', Validators.compose([Validators.required])],
      telefonoResidencia: ['', Validators.compose([Validators.required, Validators.minLength(7),
      Validators.maxLength(10), Validators.pattern('[\\0-9]*')])],
      sector: ['', Validators.compose([Validators.required])],
    });


    this.DatosRepresentanteFormGroup = this._formBuilder.group({
      ResponsableContratacion: ['', Validators.compose([Validators.required])],
      CedulaRepresentante: ['', {
        validators: [
          Validators.required, Validators.minLength(10),
          Validators.maxLength(10),
          Validators.pattern('[\\0-9]*')], asyncValidators: [this.cedula()]
      }],
      NombreRepresentante: ['', Validators.compose([Validators.required, Validators.pattern('[\\a-zA-ZáéíóúñÁÉÍÓÚÑ ]*')])],
      TelefonoCelularRepresentante: ['', Validators.compose([Validators.required, Validators.minLength(7),
      Validators.maxLength(10), Validators.pattern('[\\0-9]*')])],
      EmailRepresentanteA: ['', Validators.compose([Validators.required, Validators.email])],


      /* CedulaOtroRepresentante: ['', {
         validators: [
           Validators.required, Validators.minLength(10),
           Validators.maxLength(10),
           Validators.pattern('[\\0-9]*')], asyncValidators: [this.cedula()]
       }],*/
      NombreOtroRepresentante: ['', Validators.compose([Validators.pattern('[\\a-zA-ZáéíóúñÁÉÍÓÚÑ ]*')])],
      TelefonoCelularOtroRepresentante: ['', Validators.compose([Validators.minLength(7),
      Validators.maxLength(10), Validators.pattern('[\\0-9]*')])],
      EmailOtroRepresentante: ['', Validators.compose([Validators.email])],

      ParentescoReferenciaFamiliar: ['', Validators.compose([Validators.required, Validators.pattern('[\\a-zA-ZáéíóúñÁÉÍÓÚÑ ]*')])],
      NombreReferenciaFamiliar: ['', Validators.compose([Validators.required, Validators.pattern('[\\a-zA-ZáéíóúñÁÉÍÓÚÑ ]*')])],
      TelefonoReferenciaFamiliar: ['', Validators.compose([Validators.minLength(7),
      Validators.maxLength(9), Validators.pattern('[\\0-9]*')])],
      CelularReferenciaFamiliar: ['', Validators.compose([Validators.required, Validators.minLength(10),
      Validators.maxLength(10), Validators.pattern('[\\0-9]*')])]

    });



    this.DatosFacturacionFormGroup = this._formBuilder.group({
      TipoDocumento: ['', Validators.compose([Validators.required])],
      CedulaoRuc: ['', Validators.compose([Validators.required, Validators.pattern('[\\0-9]*')])],
      NombreFactura: ['', Validators.compose([Validators.required, Validators.pattern('[\\a-zA-ZáéíóúñÁÉÍÓÚÑ ]*')])],
      TelefonoFactura: ['', Validators.compose([Validators.required, Validators.minLength(7),
      Validators.maxLength(10), Validators.pattern('[\\0-9]*')])],

      DireccionFactura: ['', Validators.compose([Validators.required])],
      EmailFactura: ['', Validators.compose([Validators.required, Validators.email])],
    });


    this.DatosServicioTransporteFormGroup = this._formBuilder.group({
      TipoServicioTransporte: ['', Validators.compose([Validators.required])],
      DireccionExacta: ['', Validators.compose([Validators.required])],
      DireccionExactaRetorno: [''],

    });


  }

  /*  ************************************ */
  /*  ************************************ */
  /*  *************PRIMER FORM**************** */

  get Colegio() { return this.ColegioFormGroup.controls.Colegio }
  get identification() { return this.ColegioFormGroup.controls.identification }

  /*  ************************************ */
  /*  ************************************ */
  /*  *************SEGUNDO FORM**************** */

  get apellidosCompletos() { return this.DatosEstudianteFormGroup.controls.apellidosCompletos }
  get nombresCompletos() { return this.DatosEstudianteFormGroup.controls.nombresCompletos }
  get gradoPromovido() { return this.DatosEstudianteFormGroup.controls.gradoPromovido }
  get paralelo() { return this.DatosEstudianteFormGroup.controls.paralelo }
  get edad() { return this.DatosEstudianteFormGroup.controls.edad }
  get callePrincipal() { return this.DatosEstudianteFormGroup.controls.callePrincipal }
  get calleSecundaria() { return this.DatosEstudianteFormGroup.controls.calleSecundaria }
  get casaNo() { return this.DatosEstudianteFormGroup.controls.casaNo }
  get referencia() { return this.DatosEstudianteFormGroup.controls.referencia }
  get telefonoResidencia() { return this.DatosEstudianteFormGroup.controls.telefonoResidencia }
  get sector() { return this.DatosEstudianteFormGroup.controls.sector }



  /*  ************************************ */
  /*  ************************************ */
  /*  *************TERCER FORM**************** */

  get ResponsableContratacion() { return this.DatosRepresentanteFormGroup.controls.ResponsableContratacion }
  get CedulaRepresentante() { return this.DatosRepresentanteFormGroup.controls.CedulaRepresentante }
  get NombreRepresentante() { return this.DatosRepresentanteFormGroup.controls.NombreRepresentante }
  get TelefonoCelularRepresentante() { return this.DatosRepresentanteFormGroup.controls.TelefonoCelularRepresentante }
  get EmailRepresentanteA() { return this.DatosRepresentanteFormGroup.controls.EmailRepresentanteA }

  get NombreOtroRepresentante() { return this.DatosRepresentanteFormGroup.controls.NombreOtroRepresentante }
  get TelefonoCelularOtroRepresentante() { return this.DatosRepresentanteFormGroup.controls.TelefonoCelularOtroRepresentante }
  get EmailOtroRepresentante() { return this.DatosRepresentanteFormGroup.controls.EmailOtroRepresentante }

  get NombreReferenciaFamiliar() { return this.DatosRepresentanteFormGroup.controls.NombreReferenciaFamiliar }
  get TelefonoReferenciaFamiliar() { return this.DatosRepresentanteFormGroup.controls.TelefonoReferenciaFamiliar }
  get CelularReferenciaFamiliar() { return this.DatosRepresentanteFormGroup.controls.CelularReferenciaFamiliar }
  get ParentescoReferenciaFamiliar() { return this.DatosRepresentanteFormGroup.controls.ParentescoReferenciaFamiliar }


  /*  ************************************ */
  /*  ************************************ */
  /*  *************CUARTO FORM FACTURACION**************** */

  get TipoDocumento() { return this.DatosFacturacionFormGroup.controls.TipoDocumento }
  get CedulaoRuc() { return this.DatosFacturacionFormGroup.controls.CedulaoRuc }
  get NombreFactura() { return this.DatosFacturacionFormGroup.controls.NombreFactura }

  get TelefonoFactura() { return this.DatosFacturacionFormGroup.controls.TelefonoFactura }

  get DireccionFactura() { return this.DatosFacturacionFormGroup.controls.DireccionFactura }
  get EmailFactura() { return this.DatosFacturacionFormGroup.controls.EmailFactura }



  /*  ************************************ */
  /*  ************************************ */
  /*  *************QUINTO FORM MAPAS**************** */

  get TipoServicioTransporte() { return this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte }
  get DireccionExacta() { return this.DatosServicioTransporteFormGroup.controls.DireccionExacta }
  get DireccionExactaRetorno() { return this.DatosServicioTransporteFormGroup.controls.DireccionExactaRetorno }

  //


  seleccionTipoDocFact(event: any) {

    if (event === 'Cédula') {
      this.LengthFact = 10;
    } else if (event === 'RUC') {
      this.LengthFact = 13;
    }
  }

  checkValue(event: any) {

    this.estudianteAntiguo = event;
  }

  onToggleChange(event: any) {

    this.estudianteAntiguo = event;
  }

  get EmailRepresentante() {
    return this.DatosRepresentanteFormGroup.get('EmailRepresentante');
  }

  cambioTipoServicio() {
    if (this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value == 'DOBLE RUTA') {
      this.tieneRetorno = true;
    } else {
      this.tieneRetorno = false;
      this.locationDireccionRegreso = null;
    }
  }

  locationDireccionChange(location: Location) {
    this.locationDireccion = location;

    this.latitudRecoijida = location["lat"]
    this.longitudRecojida = location["lng"]

    //   this.DatosServicioTransporteFormGroup.controls['CoordenadasForm'].setErrors({ 'incorrect': false });
    //   this.DatosServicioTransporteFormGroup.get('CoordenadasForm').setValue(JSON.stringify(location));
  }

  locationDireccionRetornoChange(location: Location) {
    this.locationDireccionRegreso = location;

    this.latitudDeja = location["lat"]
    this.longitudDeja = location["lng"]

  }
  DatosServicioTransporteFormGrou: any;

  message: any;




  r = "";
  goForward(stepper: MatStepper) {

    let paso = stepper.selectedIndex

    if (this.ColegioFormGroup.status == "VALID" && paso == 0) {

      const colegio = this.ColegioFormGroup.controls.Colegio.value
      const cedula = this.ColegioFormGroup.controls.identification.value

      this.service.getdata(colegio, cedula).subscribe((resp: any) => {
        if (resp) {
          alerts.basicAlert("Actualice sus datos", "Estudiante existente", "info")
          this.DatosEstudianteFormGroup.controls.apellidosCompletos.setValue(resp.DatosEstudiante.ApellidosCompletos);
          this.DatosEstudianteFormGroup.controls.nombresCompletos.setValue(resp.DatosEstudiante.NombresCompletos);
          this.DatosEstudianteFormGroup.controls.paralelo.setValue(resp.DatosEstudiante.Paralelo);
          this.DatosEstudianteFormGroup.controls.gradoPromovido.setValue(resp.DatosEstudiante.GradoPromovido);
          this.DatosEstudianteFormGroup.controls.edad.setValue(resp.DatosEstudiante.Edad);

          this.DatosEstudianteFormGroup.controls.callePrincipal.setValue(resp.DireccionDomicilio.CallePrincipal);
          this.DatosEstudianteFormGroup.controls.calleSecundaria.setValue(resp.DireccionDomicilio.CalleSecundaria);
          this.DatosEstudianteFormGroup.controls.casaNo.setValue(resp.DireccionDomicilio.CasaNo);
          this.DatosEstudianteFormGroup.controls.referencia.setValue(resp.DireccionDomicilio.Referencia);
          this.DatosEstudianteFormGroup.controls.telefonoResidencia.setValue(resp.DireccionDomicilio.TelefonoResidencia);
          this.DatosEstudianteFormGroup.controls.sector.setValue(resp.DireccionDomicilio.Sector);


          this.DatosRepresentanteFormGroup.controls.ResponsableContratacion.setValue(resp.DatosRepresentante.ResponsableContratacion);
          this.DatosRepresentanteFormGroup.controls.CedulaRepresentante.setValue(resp.DatosRepresentante.CedulaRepresentante);
          this.DatosRepresentanteFormGroup.controls.NombreRepresentante.setValue(resp.DatosRepresentante.NombreRepresentante);
          this.DatosRepresentanteFormGroup.controls.TelefonoCelularRepresentante.setValue(resp.DatosRepresentante.TelefonoCelularRepresentante);
          this.DatosRepresentanteFormGroup.controls.EmailRepresentanteA.setValue(resp.DatosRepresentante.EmailRepresentante);

          this.DatosRepresentanteFormGroup.controls.NombreOtroRepresentante.setValue(resp.DatosRepresentante.NombreOtroRepresentante);
          this.DatosRepresentanteFormGroup.controls.TelefonoCelularOtroRepresentante.setValue(resp.DatosRepresentante.TelefonoCelularOtroRepresentante);
          this.DatosRepresentanteFormGroup.controls.EmailOtroRepresentante.setValue(resp.DatosRepresentante.EmailOtroRepresentante);
          this.DatosRepresentanteFormGroup.controls.CelularReferenciaFamiliar.setValue(resp.DatosRepresentante.CelularReferenciaFamiliar);
          this.DatosRepresentanteFormGroup.controls.NombreReferenciaFamiliar.setValue(resp.DatosRepresentante.NombreReferenciaFamiliar);
          this.DatosRepresentanteFormGroup.controls.ParentescoReferenciaFamiliar.setValue(resp.DatosRepresentante.ParentescoReferenciaFamiliar);
          this.DatosRepresentanteFormGroup.controls.TelefonoReferenciaFamiliar.setValue(resp.DatosRepresentante.TelefonoReferenciaFamiliar);



          this.DatosFacturacionFormGroup.controls.TipoDocumento.setValue(resp.DatosFacturacion.TipoDocumento)
          this.DatosFacturacionFormGroup.controls.CedulaoRuc.setValue(resp.DatosFacturacion.CedulaoRuc)
          this.DatosFacturacionFormGroup.controls.NombreFactura.setValue(resp.DatosFacturacion.NombreFactura)
          this.DatosFacturacionFormGroup.controls.TelefonoFactura.setValue(resp.DatosFacturacion.TelefonoFactura)
          this.DatosFacturacionFormGroup.controls.DireccionFactura.setValue(resp.DatosFacturacion.DireccionFactura)
          this.DatosFacturacionFormGroup.controls.EmailFactura.setValue(resp.DatosFacturacion.EmailFactura)
        } else {
          this.DatosEstudianteFormGroup.reset();
          this.DatosRepresentanteFormGroup.reset();
          this.DatosFacturacionFormGroup.reset();
        }
      })
    }

    if (paso == 3 && this.ColegioFormGroup.status == "VALID") {
      alerts.informationmap();
    }

    if (paso == 4 && this.latitudRecoijida == -0.172216 && this.longitudRecojida == -78.460953) {
      alerts.informationmapHelp();
      return
    }


    if (paso == 4 && this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value == "DOBLE RUTA") {
      if (!this.DatosServicioTransporteFormGroup.controls.DireccionExactaRetorno.value) {
        this.direccionRetornoP = true;
        this.r = "required";
        return
      }
      else {
        this.direccionRetornoP = false;
      }


      if (paso == 4 && this.latitudDeja == -0.172216 && this.longitudDeja == -78.460953) {
        alerts.informationmapHelp();
        return
      }

    } else {
      this.r = "";
      this.direccionRetornoP = false;
    }

    if (stepper.selectedIndex === 5) {
      if (this.DatosFacturacionFormGroup.invalid) {
        return;
      } else {
        this.guardarDatos("prueba");
        Swal.fire({
          title: 'Su solicitud de transporte se ha registrado exitosamente',
          text: "Pronto nos pondremos en contacto con usted.",
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',

          confirmButtonText: 'Aceptar'
        }).then((result) => {
          window.location.href = "/";
        })

      }

    }

    stepper.next();
  }



  goBack(stepper: MatStepper) {
    stepper.previous();
  }

  public guardarDatos(cialumno: string) {
    if (cialumno) {

      /************************* */
      /***ESTRUCURAR DATA ****/
      var colegio = this.ColegioFormGroup.controls.Colegio.value
      var cedula = this.ColegioFormGroup.controls.identification.value
      var refString = environment.nodoAmbiente + '/fichas/' + colegio + '/' + cedula;

      var dataRef = this.db.object(refString + '/IdentificacionAlumno');
      dataRef.set({ CIEstudiante: cedula });
      var dataRef = this.db.object(refString + '/FechaGuarda');
      dataRef.set(firebase.default.database['ServerValue']['TIMESTAMP']);

      var dataRef = this.db.object(refString + '/DatosEstudiante');
      dataRef.set(
        {
          ApellidosCompletos: this.DatosEstudianteFormGroup.controls.apellidosCompletos.value,
          NombresCompletos: this.DatosEstudianteFormGroup.controls.nombresCompletos.value,
          GradoPromovido: this.DatosEstudianteFormGroup.controls.gradoPromovido.value,
          Paralelo: this.DatosEstudianteFormGroup.controls.paralelo.value,
          Edad: this.DatosEstudianteFormGroup.controls.edad.value
        });

      var dataRef = this.db.object(refString + '/DireccionDomicilio');
      dataRef.set(
        {
          CallePrincipal: this.DatosEstudianteFormGroup.controls.callePrincipal.value,
          CalleSecundaria: this.DatosEstudianteFormGroup.controls.calleSecundaria.value,
          CasaNo: this.DatosEstudianteFormGroup.controls.casaNo.value,
          Referencia: this.DatosEstudianteFormGroup.controls.referencia.value,
          Sector: this.DatosEstudianteFormGroup.controls.sector.value,
          TelefonoResidencia: this.DatosEstudianteFormGroup.controls.telefonoResidencia.value
        }
      );



      if (this.DatosRepresentanteFormGroup.controls.NombreOtroRepresentante.value) {
        var NombreOtroRepresentante = this.DatosRepresentanteFormGroup.controls.NombreOtroRepresentante.value;
      } else {
        NombreOtroRepresentante = "";
      }


      if (this.DatosRepresentanteFormGroup.controls.TelefonoCelularOtroRepresentante.value) {
        var TelefonoCelularOtroRepresentante = this.DatosRepresentanteFormGroup.controls.TelefonoCelularOtroRepresentante.value;
      } else {
        TelefonoCelularOtroRepresentante = "";
      }



      if (this.DatosRepresentanteFormGroup.controls.EmailOtroRepresentante.value) {
        var EmailOtroRepresentante = this.DatosRepresentanteFormGroup.controls.EmailOtroRepresentante.value;
      } else {
        EmailOtroRepresentante = "";
      }

      var dataRefD = this.db.object(refString + '/DatosRepresentante');
      dataRefD.set({
        ResponsableContratacion: this.DatosRepresentanteFormGroup.controls.ResponsableContratacion.value,
        CedulaRepresentante: this.DatosRepresentanteFormGroup.controls.CedulaRepresentante.value,
        NombreRepresentante: this.DatosRepresentanteFormGroup.controls.NombreRepresentante.value,
        TelefonoCelularRepresentante: this.DatosRepresentanteFormGroup.controls.TelefonoCelularRepresentante.value,
        EmailRepresentante: this.DatosRepresentanteFormGroup.controls.EmailRepresentanteA.value,


        NombreOtroRepresentante: NombreOtroRepresentante,
        TelefonoCelularOtroRepresentante: TelefonoCelularOtroRepresentante,
        EmailOtroRepresentante: EmailOtroRepresentante,
        CelularReferenciaFamiliar: this.DatosRepresentanteFormGroup.controls.CelularReferenciaFamiliar.value,
        NombreReferenciaFamiliar: this.DatosRepresentanteFormGroup.controls.NombreReferenciaFamiliar.value,
        ParentescoReferenciaFamiliar: this.DatosRepresentanteFormGroup.controls.ParentescoReferenciaFamiliar.value,
        TelefonoReferenciaFamiliar: this.DatosRepresentanteFormGroup.controls.TelefonoReferenciaFamiliar.value,
      });



      var dataRef = this.db.object(refString + '/DatosFacturacion');
      dataRef.set({
        CedulaoRuc: this.DatosFacturacionFormGroup.controls.CedulaoRuc.value,
        DireccionFactura: this.DatosFacturacionFormGroup.controls.DireccionFactura.value,
        EmailFactura: this.DatosFacturacionFormGroup.controls.EmailFactura.value,
        NombreFactura: this.DatosFacturacionFormGroup.controls.NombreFactura.value,
        TelefonoFactura: this.DatosFacturacionFormGroup.controls.TelefonoFactura.value,
        TipoDocumento: this.DatosFacturacionFormGroup.controls.TipoDocumento.value
      });


      if (this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value === 'DOBLE RUTA') {


        var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/');
        dataRefegreso.set({
          DireccionExacta: this.DatosServicioTransporteFormGroup.controls.DireccionExacta.value,
          DireccionExactaRetorno: this.DatosServicioTransporteFormGroup.controls.DireccionExactaRetorno.value,
          TipoServicioTransporte: this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value,
        })


        var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/Coordenadas/');
        dataRefegreso.set({
          lng: this.longitudRecojida,
          lat: this.latitudRecoijida,
          zoom: 16
        })

        var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/CoordenadasRetorno/');
        dataRefegreso.set({
          lng: this.longitudDeja,
          lat: this.latitudDeja,
          zoom: 16
        })
      }


      else if (this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value === 'OPCIONAL SOLO ENTRADA') {


        var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/');
        dataRefegreso.set({
          TipoServicioTransporte: this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value,
          DireccionExacta: this.DatosServicioTransporteFormGroup.controls.DireccionExacta.value,

        })


        var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/Coordenadas/');
        dataRefegreso.set({
          lng: this.longitudRecojida,
          lat: this.latitudRecoijida,
          zoom: 16
        })

        this.db.object(refString + '/DatosServicioTransporte/CoordenadasRetorno').remove();
      }
      else if (this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value === 'COMPLETO') {


        var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/');
        dataRefegreso.set({
          TipoServicioTransporte: this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value,
          DireccionExacta: this.DatosServicioTransporteFormGroup.controls.DireccionExacta.value,

        })


        var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/Coordenadas/');
        dataRefegreso.set({
          lng: this.longitudRecojida,
          lat: this.latitudRecoijida,
          zoom: 16
        })
        this.db.object(refString + '/DatosServicioTransporte/CoordenadasRetorno').remove();
      }


      else if (this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value === 'OPCIONAL SOLO SALIDA') {

        var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/');
        dataRefegreso.set({
          TipoServicioTransporte: this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value,
          DireccionExacta: this.DatosServicioTransporteFormGroup.controls.DireccionExacta.value,

        })



        var dataRefegreso = this.db.object(refString + '/DatosServicioTransporte/CoordenadasRetorno/');
        dataRefegreso.set({

          lng: this.longitudRecojida,
          lat: this.latitudRecoijida,
          zoom: 16
        })
        this.db.object(refString + '/DatosServicioTransporte/Coordenadas').remove();
      }


    }

  }



  invalidField(field: string) {
    return functions.invalidFields(field, this.ColegioFormGroup, this.formSubmittedUnidad);
  }


  invalidFieldSteapDos(field: string) {
    return functions.invalidFields(field, this.DatosEstudianteFormGroup, this.formSubmittedUnidad);
  }



  invalidFieldStepTres(field: string) {
    return functions.invalidFields(field, this.DatosRepresentanteFormGroup, this.formSubmittedUnidad);
  }


  invalidFieldStepCuatro(field: string) {
    return functions.invalidFields(field, this.DatosFacturacionFormGroup, this.formSubmittedUnidad);
  }


  invalidFieldStepCinco(field: string) {
    return functions.invalidFields(field, this.DatosRepresentanteFormGroup, this.formSubmittedUnidad);
  }


  invalidFieldStepSeis(field: string) {
    return functions.invalidFields(field, this.DatosRepresentanteFormGroup, this.formSubmittedUnidad);
  }

  verificador = true
  cedula() {
    return (control: AbstractControl) => {
      const cedula = control.value;


      let cedulaCorrecta = false;
      if (cedula.length == 10) {
        let tercerDigito = parseInt(cedula.substring(2, 3));
        if (tercerDigito < 6) {
          let coefValCedula = [2, 1, 2, 1, 2, 1, 2, 1, 2];
          let verificador = parseInt(cedula.substring(9, 10));
          let suma: number = 0;
          let digito: number = 0;
          for (let i = 0; i < (cedula.length - 1); i++) {
            digito = parseInt(cedula.substring(i, i + 1)) * coefValCedula[i];
            suma += ((parseInt((digito % 10) + '') + (parseInt((digito / 10) + ''))));
          }
          suma = Math.round(suma);
          if ((Math.round(suma % 10) == 0) && (Math.round(suma % 10) == verificador)) {
            cedulaCorrecta = true;
          }
          else if ((10 - (Math.round(suma % 10))) == verificador) {
            cedulaCorrecta = true;
          } else {
            cedulaCorrecta = false;
          }
        } else {
          cedulaCorrecta = false;
        }
      } else {
        cedulaCorrecta = false;
      }
      if (!cedulaCorrecta) {

      }
      this.verificador = cedulaCorrecta;

      return new Promise((resolve) => {
        if (this.verificador != true) {
          resolve({ vacuna: true })
          this.ColegioFormGroup.controls.identification.updateValueAndValidity({ emitEvent: false });
        }
        else {
          resolve({})
        }
      })
    }
  }


  notificacion = '  Estimado padre de familia, si usted requiere contratar el servicio de transporte escolar para el periodo actual le agradecemos llenar la ficha que se despliega a continuación, según el art. 3, de la normativa del Ministerio de Educación manifiesta que el uso de transporte es libre y voluntario. Recuerde que los pagos son los 10 primeros días de cada mes sin excepción alguna, lea cuidadosamente el contrato adjunto para tomar su decisión personal. La Operadora de transporte garantizará la movilización del estudiantado una vez receptado el contrato para dicha prestación, el cual será direccionado por el Sr. Transportista de manera personal una vez realizadas las verificaciones pertinentes, y este será el único documento habilitante para la prestación del servicio. POR FAVOR ANALICE SU ECONOMÍA ANTES DE SEGUIR CON ESTE PROCESO.';

  getFiltroByNombreVacuna() {
    return null;
  }

  cedulaboolean = false;
  rucboolean = false;
  validadorCedulaRuc() {


    let cedula = this.DatosFacturacionFormGroup.controls.CedulaoRuc.value;
    if (cedula != " ") {
      if (this.DatosFacturacionFormGroup.controls.TipoDocumento.value == "Cédula") {

        if (cedula.length == 10) {
        } else {
          this.DatosFacturacionFormGroup.controls.CedulaoRuc.reset()
          this.cedulaboolean = true;
        }
      } else {
        this.cedulaboolean = false;
        if (cedula.length == 13) {
        } else {
          this.DatosFacturacionFormGroup.controls.CedulaoRuc.reset()
          this.cedulaboolean = true;
        }
      }
    }
  }


  helperMap() {
    alerts.informationmapHelp();
  }



}
